import React from 'react'
import './CareerTestResult.css';
import RISAECgraph from '../../assets/img/distribution.png';

function CareerTestResult({ studentScore }) {
    const riasecMap = {
        'R': 'Realistic',
        'I': 'Investigative',
        'A': 'Artistic',
        'S': 'Social',
        'E': 'Enterprising',
        'C': 'Conventional'
    }
    return (
        <div className='testResults__container'>
            <h2>These are the results from the <b>IIP RIASEC Markers</b>. Your scores for each of the 6 basic interest areas are below.</h2>

            <table cellSpacing={0}>
                <tbody><tr>
                    <td align="right" className='scoreType'><big>Realistic</big>&nbsp;</td>
                    <td><div className='scoreContainer' style={{ width: `${studentScore.r * 10}px`, backgroundColor: "#FF7F50" }}
                    ><small>&nbsp;{studentScore.r}</small></div></td>
                </tr>
                    <tr>
                        <td align="right" className='scoreType'><big>Investigative</big>&nbsp;</td>
                        <td><div className='scoreContainer' style={{ width: `${studentScore.i * 10}px`, backgroundColor: "#87CEFA" }}
                        ><small>&nbsp;{studentScore.i}</small></div></td>
                    </tr>
                    <tr>
                        <td align="right" className='scoreType'><big>Artistic</big>&nbsp;</td>
                        <td><div className='scoreContainer' style={{ width: `${studentScore.a * 10}px`, backgroundColor: "#66CDAA" }}
                        ><small>&nbsp;{studentScore.a}</small></div></td>
                    </tr>
                    <tr>
                        <td align="right" className='scoreType'><big>Social</big>&nbsp;</td>
                        <td><div className='scoreContainer' style={{ width: `${studentScore.s * 10}px`, backgroundColor: "#EE82EE" }}
                        ><small>&nbsp;{studentScore.s}</small></div></td>
                    </tr>
                    <tr>
                        <td align="right" className='scoreType'><big>Enterprising</big>&nbsp;</td>
                        <td><div className='scoreContainer' style={{ width: `${studentScore.e * 10}px`, backgroundColor: "#F4A460" }}
                        ><small>&nbsp;{studentScore.e}</small></div></td>
                    </tr>
                    <tr>
                        <td align="right" className='scoreType'><big>Conventional</big>&nbsp;</td>
                        <td><div className='scoreContainer' style={{ width: `${studentScore.c * 10}px`, backgroundColor: "#6B8E23" }}><small>&nbsp;{studentScore.c}</small></div></td>
                    </tr>
                </tbody></table>

            <div className="testResults__graph">
                <p className='testResults__graphTxt'>Scores range from 0 to 32. This distribution of scores are below. This graph shows what percent of people received a specific score, for each of the six scales.</p>
                <img className='testResults__graphImg' src={RISAECgraph} alt="RIASEC Graph" />
                <p className='testResults__graphTxt'>You can see that the people who have taken this test are somewhat biased towards S, and away from R and C.</p>
            </div>

            <div className="testResults__result">
                <h2 className='testResults__resultTitle'>Type</h2>
                <p className='testResults__desc'>Your highest score was for the
                    <span className="testResults__descMain"> {studentScore.result}</span> occupational interest.
                    .</p>
            </div>

            <div className="testResults__result">
                <h2 className='testResults__resultTitle'>Suitable Careers</h2>
                <p className='testResults__desc'>Check Out the following link for relevant fields that suit your occupational interest.
                </p>
                <p className='testResults__desc'>
                    <a className="testResults__link"
                        href={`http://www.onetonline.org/explore/interests/${riasecMap[studentScore.result[0]]}/${riasecMap[studentScore.result[1]]}/${riasecMap[studentScore.result[2]]}`}>Check Here</a>
                    .</p>
            </div>
        </div >
    )
}

export default CareerTestResult